'use strict';

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('./Utility');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    loadFbLoginApi: function loadFbLoginApi() {

        window.fbAsyncInit = function () {
            _parse2.default.FacebookUtils.init({
                appId: FB_APP_ID,
                cookie: true, // enable cookies to allow the server to access
                // the session
                xfbml: true, // parse social plugins on this page
                version: 'v2.5' // use version 2.1
            });
            //FB.getLoginStatus(function(response) {
            //this.statusChangeCallback(response);
            //}.bind(this));
        };

        // console.log("Loading fb api");
        // Load the SDK asynchronously
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/all.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },


    // fetchParseConfig() {
    //     Parse.Config.get()
    //         .then(
    //             (config) => {
    //                 console.log(`Config was fetched from the server. ${config}`);
    //             },
    //             (error) => {
    //                 let errorCode = error.code;
    //                 let errorMessage = error.message;
    //
    //                 if (errorCode == Parse.Error.INVALID_SESSION_TOKEN) {
    //                     console.log(`Error: ${errorMessage}`);
    //                     // logout user account if logged in
    //                     Utils.logOut();
    //                 }
    //             }
    //         );
    // },

    attachPaymentMethod: function attachPaymentMethod(userId, sessionToken, userObject) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "attachPaymentMethod",
            userId: userId,
            userSession: sessionToken,
            params: userObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // deleteUserRequest(userId, sessionToken){
    // return this.sendDeleteUserRequestt(userId, sessionToken);
    // },

    sendDeleteUserRequest: function sendDeleteUserRequest(userId, sessionToken) {
        // console.log("userId :" + userId);
        // console.log("sessionToken :" + sessionToken);

        return $.ajax({
            // url     : 'https://api.parse.com/1/users/' + userId,
            url: 'https://wlparse-test.herokuapp.com/parse/classes/_User/' + userId,
            type: 'DELETE',
            headers: {
                'X-Parse-Application-Id': "wlparse-test-app-id",
                'X-Parse-REST-API-Key': "B77W5iK6lsci1nz9VNSkg8dqzdaY21X76dd6ASdt",
                'X-Parse-Session-Token': sessionToken
            },
            success: function success() {
                // Do something with the result
                Utils.logOut(this.context.router, false);
                // Parse.User.logOut();
            }
        }).fail(function (responseData) {
            if (responseData.responseCode) {
                console.error(responseData.responseCode);
            }
        });
    },
    sendAjaxRequest: function sendAjaxRequest(URL, dataToSend) {
        return $.ajax({
            type: 'POST',
            url: URL,
            headers: { "X-WL-Web-Key": "TEST-123" },
            crossDomain: true,
            data: JSON.stringify(dataToSend),
            dataType: 'json'
        }).fail(function (responseData) {
            if (responseData.responseCode) {
                console.error(responseData.responseCode);
            }
        });
    },


    // sendGoogleAuthRequest(idToken) {
    //     const URL = `${CLOUD_URL}GoogleAuth`;
    //     const dataToSend = {
    //         functionName : "validateAuthToken",
    //         params       : {
    //             idToken
    //         }
    //     };
    //
    //     return this.sendAjaxRequest(URL, dataToSend);
    // },

    applyCoupon: function applyCoupon(isGuest, sessionToken, userId, bizId, locId, couponCode, subTotal) {
        var URL = CLOUD_URL + 'Coupon';

        var dataToSend = {
            functionName: "validateCoupon",
            userId: userId,
            userSession: sessionToken,
            params: {
                isGuest: isGuest, bizId: bizId, locId: locId, couponCode: couponCode, subTotal: subTotal
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // getPastOrders(sessionToken, id, userId, limit, isBizId) {
    getPastOrders: function getPastOrders(sessionToken, id, userId, limit, isLocId) {
        var URL = CLOUD_URL + 'Order';

        var params = {
            userId: userId
        };

        // if (isBizId) {
        //     params["bizId"] = id;
        // } else {
        //     params["locId"] = id;
        // }


        if (isLocId) {
            params["locId"] = id;
        }

        var dataToSend = {
            functionName: "getPastOrders",
            userId: userId, params: params,
            userSession: sessionToken
        };

        if (limit) {
            dataToSend.params["limit"] = limit;
        }

        params["sendDineInOrders"] = true;

        // console.log(JSON.stringify(dataToSend));

        return this.sendAjaxRequest(URL, dataToSend);
    },
    markFavOrder: function markFavOrder(sessionToken, userId, orderId, isFavorite) {
        var URL = CLOUD_URL + 'Order';

        var dataToSend = {
            functionName: "markFavoriteOrder",
            userId: userId,
            userSession: sessionToken,
            params: {
                orderId: orderId, isFavorite: isFavorite
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    getLocationDetail: function getLocationDetail() {
        var URL = CLOUD_URL + 'LocationDetail';
        // const headers = { "X-WL-Web-Key" : "TEST-123" };

        var dataToSend = {
            functionName: "bootUp",
            params: {
                appName: window.location.hostname,
                source: {
                    agent: 'web',
                    version: '1.0',
                    browser: navigator.userAgent
                }
            }
        };
        return this.sendAjaxRequest(URL, dataToSend);
    },
    getAllLocations: function getAllLocations() {

        var URL = CLOUD_URL + 'BusinessDetail';
        var dataToSend = {
            functionName: "getAllLocations",
            params: {
                appName: window.location.hostname,
                // appName : "strawhatpizza.freshbytes.io", // How to run any onboarding web application
                source: {
                    agent: 'web',
                    version: '1.0',
                    browser: navigator.userAgent
                }
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // SK : Change Here
    getGroupDetails: function getGroupDetails(bizId, includePointer) {
        var locId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        // console.log("biz here group " + bizId);
        var URL = CLOUD_URL + 'GroupDetail';
        var dataToSend = {
            functionName: "getGroupDetails",
            params: {
                bizId: bizId
            }
        };
        if (locId) {
            dataToSend.params["locId"] = locId;
        }

        if (includePointer) {
            dataToSend.params["pointers"] = ["bizId"];
        }

        // console.log(dataToSend);

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // SK- Change Here
    getItemDetails: function getItemDetails(bizId, includePointer) {
        var locId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


        //  console.log("biz here " + bizId);

        var URL = CLOUD_URL + 'ItemDetail';
        var dataToSend = {
            functionName: "getItemDetails",
            params: {
                bizId: bizId
            }
        };

        if (locId) {
            dataToSend.params["locId"] = locId;
        }

        if (includePointer) {
            dataToSend.params["pointers"] = ["bizId", "groupDetailPointer"];
        }

        //   console.log(dataToSend);

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // getAllDataViaRestwPtr(locationIndex) {
    //     const data = {};
    //     const grpIdGrpDetailMap = {};
    //     const self = this;
    //     return this.getAllLocations()
    //      .then(
    //          (responseData) => {
    //              if (responseData.data) {
    //                  sessionStorage.setItem("responseData", JSON.stringify(responseData));
    //                  const locDetails        = responseData.data.BusinessLocations;
    //                  if (locationIndex) {
    //                      data.LocationDetail = locDetails[locationIndex];
    //                  } else {
    //                      data.LocationDetail = locDetails[0];
    //                  }
    //              }
    //              return data.LocationDetail;
    //          },
    //          (responseData) => {
    //              console.log("Error while fetching location detail !");
    //              if (responseData && responseData.responseJSON) {
    //                  console.log(responseData.responseJSON.error.message);
    //              }
    //          }
    //      )
    //      .then(
    //          (locationDetail) => {
    //              const locId = locationDetail.objectId;
    //              return self.getGroupDetails(locId, true);
    //          })
    //      .then(
    //          (responseData) => {
    //              if (responseData.data) {
    //                  const groupDetails  = responseData.data;
    //                  data.GroupDetails = groupDetails;
    //              }
    //              return data;
    //          },
    //          (responseData) => {
    //              console.log("Error while fetching group details !");
    //              if (responseData && responseData.responseJSON) {
    //                  console.log(responseData.responseJSON.error.message);
    //              }
    //          }
    //      )
    //      .then(
    //          (reData) => {
    //              const locationDetail = reData.LocationDetail;
    //              const locId          = locationDetail.objectId;
    //              console.log("3 +");
    //              console.log(locationDetail.bizId)
    //              const bizId = locationDetail.bizId;
    //              return self.getItemDetails(locId, true);
    //          }
    //      )
    //      .then(
    //          (responseData) => {
    //              console.log(responseData.data);
    //
    //              if (responseData.data) {
    //
    //                  const itemDetails  = responseData.data;
    //                  data.ItemDetails = itemDetails;
    //              } else if (responseData.error) {
    //                  console.log(responseData.error);
    //              }
    //              return data;
    //          },
    //          (responseData) => {
    //              console.log("Error while fetching Item details !");
    //              if (responseData && responseData.responseJSON) {
    //                  console.log(responseData.responseJSON.error.message);
    //              }
    //          }
    //      )
    //      .then((tData) => tData);
    // },

    getAllDataViaRest: function getAllDataViaRest(activeLocationIndex, activeLocationId) {
        var data = {};
        var grpIdGrpDetailMap = {};
        var self = this;

        return this.getAllLocations().then(function (responseData) {
            if (responseData.data) {
                var locDetails = responseData.data.BusinessLocations;
                data.BusinessLocations = responseData.data.BusinessLocations;
                data.BusinessDetail = responseData.data.BusinessDetail;

                if (activeLocationId != null) {
                    // based on the active location ID(ObjectId) set the active location

                    var locationDetail = locDetails.filter(function (location) {
                        return location.objectId == activeLocationId;
                        // return location.objectId == '9lE5hysZGP';
                    });

                    // if location Object Id match then return the Location object otherwise return the first array
                    if (locationDetail.length > 0) {
                        data.LocationDetail = locationDetail[0];
                    } else {
                        data.LocationDetail = locDetails[0];
                    }
                } else if (activeLocationIndex != null) {
                    // based on the active location index set the active location

                    var _locationDetail = locDetails[activeLocationIndex];

                    data.LocationDetail = _locationDetail;
                } else {
                    // default set the first location as a active location
                    data.LocationDetail = locDetails[0];
                }
            }
            return data;
        },
        // error case
        function (errorResponseData) {
            // console.log("Error while fetching business locations !");
            if (errorResponseData && errorResponseData.responseJSON) {
                console.log(errorResponseData.responseJSON.error.message);
            }
        }).then(function (reData) {
            var businessDetail = reData.BusinessDetail;
            var bizId = businessDetail.objectId;

            // console.log("getGroupDetails: ------");

            // check if the isMenuSameForAllLocation is false or not
            if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == false) {

                var locationDetail = reData.LocationDetail;
                var locId = locationDetail.objectId;

                return self.getGroupDetails(bizId, false, locId);
            } else {
                return self.getGroupDetails(bizId, false);
            }
        }).then(function (responseData) {
            if (responseData.data) {
                var groupDetails = responseData.data;
                groupDetails.forEach(function (groupDetail) {
                    grpIdGrpDetailMap[groupDetail.objectId] = groupDetail;
                    groupDetail.bizId = Object.assign({}, groupDetail.bizId, data.BusinessDetail);
                });
                data.GroupDetails = groupDetails;
            }
            return data;
        }, function (errorResponseData) {
            // console.log("Error while fetching group details !");
            if (errorResponseData && errorResponseData.responseJSON) {
                console.log(errorResponseData.responseJSON.error.message);
            }
        }).then(function (reData) {
            var businessDetail = reData.BusinessDetail;
            var bizId = businessDetail.objectId;

            //  console.log("getItemDetails: ------");

            // check if the isMenuSameForAllLocation is false or not
            if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == false) {

                var locationDetail = reData.LocationDetail;
                var locId = locationDetail.objectId;

                return self.getItemDetails(bizId, false, locId);
            } else {
                return self.getItemDetails(bizId, false);
            }
        }).then(function (responseData) {
            // console.log(responseData.data);
            if (responseData.data) {
                var itemDetails = responseData.data;
                itemDetails.forEach(function (itemDetail) {
                    itemDetail.bizId = Object.assign({}, itemDetail.bizId, data.BusinessDetail);
                    itemDetail.groupDetailPointer = Object.assign({}, itemDetail.groupDetailPointer, grpIdGrpDetailMap[itemDetail.groupDetailPointer.objectId]);
                });
                data.ItemDetails = itemDetails;
            }
            return data;
        }, function (errorResponseData) {
            console.log("Error while fetching Item details !");
            if (errorResponseData && errorResponseData.responseJSON) {
                console.log(errorResponseData.responseJSON.error.message);
            }
        }).then(function (tData) {
            return tData;
        });
    },


    // getGroupsItemsForBusinessViaRest(businessDetail) {
    //     const data = {};
    //     const grpIdGrpDetailMap = {};
    //     const self = this;
    //     const bizId = businessDetail.objectId;
    //     data.BusinessDetail = businessDetail;
    //
    //     return self.getGroupDetails(bizId, false)
    //         .then(
    //             (responseData) => {
    //                 if (responseData.data) {
    //                     const groupDetails = responseData.data;
    //                     groupDetails.forEach((groupDetail) => {
    //                         grpIdGrpDetailMap[groupDetail.objectId] = groupDetail;
    //                         groupDetail.bizId = Object.assign({}, groupDetail.bizId, data.BusinessDetail);
    //                     });
    //                     data.GroupDetails = groupDetails;
    //                 }
    //                 return data;
    //             },
    //             (responseData) => {
    //                 console.log("Error while fetching group details !");
    //                 if (responseData && responseData.responseJSON) {
    //                     console.log(responseData.responseJSON.error.message);
    //                 }
    //             })
    //         .then(
    //             (reData) => {
    //                 const businessDetailInner = reData.BusinessDetail;
    //                 const bizIdInner = businessDetailInner.objectId;
    //                 console.log("2 +");
    //                 return self.getItemDetails(bizIdInner, false);
    //             })
    //         .then(
    //             (responseData) => {
    //                 if (responseData.data) {
    //                     let itemDetails = responseData.data;
    //                     itemDetails.forEach((itemDetail) => {
    //                         itemDetail.bizId = Object.assign({}, itemDetail.bizId, data.BusinessDetail);
    //                         itemDetail.groupDetailPointer = Object.assign({}, itemDetail.groupDetailPointer, grpIdGrpDetailMap[itemDetail.groupDetailPointer.objectId]);
    //                     });
    //                     data.ItemDetails = itemDetails;
    //                 }
    //                 return data;
    //             },
    //             (responseData) => {
    //                 console.log("Error while fetching Item details !");
    //                 if (responseData && responseData.responseJSON) {
    //                     console.log(responseData.responseJSON.error.message);
    //                 }
    //             })
    //         .then((tData) => tData);
    // },

    // Comment by SK
    // getAllData() {
    //     let data = {};
    //
    //     const dataToSend = {
    //         appName : window.location.hostname,
    //         source  : {
    //             agent   : 'web',
    //             version : '1.0',
    //             browser : navigator.userAgent
    //         }
    //     };
    //
    //     return Parse.Cloud.run('bootUp', dataToSend)
    //         .then((ob) => {
    //             data.LocationDetail = ob;
    //             return ob;
    //         })
    //         .then((ob) => {
    //
    //             let LocDetail = Parse.Object.extend("LocationDetail");
    //             let locationDetailPointer = new LocDetail();
    //             locationDetailPointer.id = ob.objectId;
    //
    //             let GroupDetail = Parse.Object.extend("GroupDetail");
    //             let query = new Parse.Query(GroupDetail);
    //
    //             query.equalTo("locationDetailPointer", locationDetailPointer);
    //             return query.find();
    //         })
    //         .then((results) => {
    //             data.GroupDetails = results;
    //             return data;
    //         })
    //         .then((data) => {
    //
    //             let ob = data.LocationDetail;
    //             let LocDetail = Parse.Object.extend("LocationDetail");
    //             let locationDetailPointer = new LocDetail();
    //             locationDetailPointer.id = ob.objectId;
    //
    //             let ItemDetail = Parse.Object.extend("ItemDetail");
    //             let query = new Parse.Query(ItemDetail);
    //
    //             query.equalTo("locationDetailPointer", locationDetailPointer);
    //             return query.find();
    //         })
    //         .then((results) => {
    //             data.ItemDetails = results;
    //             return data;
    //         })
    //         .then((data) => {
    //                 return data;
    //             },
    //             (error) => {
    //                 console.log(error);
    //             });
    // },

    // Stripe related api methods
    findCustomerData: function findCustomerData(userId, sessionToken, customerId) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "findCustomerData",
            userId: userId,
            userSession: sessionToken,
            params: {
                customerId: customerId
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    createCustomerOnStripe: function createCustomerOnStripe(userId, sessionToken, customerId, customerDetails, token) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "createCustomer",
            userId: userId,
            userSession: sessionToken,
            params: {
                userId: userId,
                customerId: customerId,
                customerDetails: customerDetails,
                token: token
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    deletePaymentMethod: function deletePaymentMethod(userId, sessionToken, customerId, token) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "deletePaymentMethod",
            userId: userId,
            userSession: sessionToken,
            params: {
                customerId: customerId,
                token: token
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    acceptPayment: function acceptPayment(userId, sessionToken, paymentObject) {
        var URL = CLOUD_URL + 'Order';

        var dataToSend = {
            functionName: "acceptPayment",
            userId: userId,
            userSession: sessionToken,
            params: paymentObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },


    // Get Payment Intent
    createPaymentIntent: function createPaymentIntent(userId, sessionToken, orderObject) {
        var URL = CLOUD_URL + 'Order';

        var dataToSend = {
            functionName: "createPaymentIntent",
            userId: userId,
            userSession: sessionToken,
            params: orderObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },


    //get gift card payment intent
    createGiftCardPaymentIntent: function createGiftCardPaymentIntent(userId, sessionToken, orderObject) {
        // console.log("orderObject: " + JSON.stringify(orderObject));

        var URL = "https://5b108c55-e603-469b-9df4-78c83ea25dff.mock.pstmn.io/payWithGiftCard";

        return $.ajax({
            method: 'POST',
            url: URL
        }).fail(function (responseData) {
            if (responseData.responseCode) {
                console.error(responseData.responseCode);
            }
        });
    },
    payWithGiftCard: function payWithGiftCard(userId, sessionToken, orderObject) {
        var URL = CLOUD_URL + 'Order';

        var dataToSend = {
            functionName: "payWithGiftCard",
            userId: userId,
            userSession: sessionToken,
            params: orderObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    updatePaymentIntent: function updatePaymentIntent(userId, sessionToken, orderObject) {
        var URL = CLOUD_URL + 'Order';

        var dataToSend = {
            functionName: "updatePaymentIntent",
            userId: userId,
            userSession: sessionToken,
            params: orderObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    getSavedCards: function getSavedCards(userId, sessionToken, userObject) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "getSavedCards",
            userId: userId,
            userSession: sessionToken,
            params: userObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    detachPaymentMethod: function detachPaymentMethod(userId, sessionToken, userObject) {
        var URL = CLOUD_URL + 'UserAccount';

        var dataToSend = {
            functionName: "detachPaymentMethod",
            userId: userId,
            userSession: sessionToken,
            params: userObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/Api.jsx
// module id = 232
// module chunks = 0